export default "__VITE_ASSET__f09e20e6__"